import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var CopyIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 141.3 153.47" }),
    React.createElement("defs", null,
        React.createElement("style", null, ".d{fill:#77b204}")),
    React.createElement("g", { id: "a" }),
    React.createElement("g", { id: "b" },
        React.createElement("g", { id: "c" },
            React.createElement("g", null,
                React.createElement("rect", { className: "d", x: "31.19", width: "110.11", height: "122.28", rx: "20.92", ry: "20.92" }),
                React.createElement("path", { className: "d", d: "M52.11,132.28c-17.05,0-30.92-13.87-30.92-30.92V21.63C9.14,23.85,0,34.41,0,47.11V127.55c0,14.31,11.6,25.92,25.92,25.92H94.19c12.7,0,23.26-9.13,25.48-21.19H52.11Z" })))))); };

export { CopyIcon as default };
